import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "loading"]
  static values = {
    filter: String
  }

  connect() {
    console.debug("Feed location controller connected")
    
    // Check if location params already exist in URL
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('user_lat') && urlParams.has('user_lng')) {
      console.debug("Location parameters already present, showing content immediately")
      this.showContent()
      return
    }

    // Show loading state and get location
    this.showLoading()
    this.waitForLocationThenLoad()
  }

  showLoading() {
    if (this.hasContentTarget) this.contentTarget.style.display = 'none'
    if (this.hasLoadingTarget) this.loadingTarget.style.display = 'block'
  }

  showContent() {
    if (this.hasLoadingTarget) this.loadingTarget.style.display = 'none'
    if (this.hasContentTarget) this.contentTarget.style.display = 'block'
  }

  async waitForLocationThenLoad() {
    try {
      const position = await window.getCurrentPosition(false); // false for standard accuracy since we don't need high precision for feed
      console.debug("Got user location for feed", position.coords)
      this.loadFeedWithLocation(position.coords.latitude, position.coords.longitude)
    } catch (error) {
      console.debug("Could not get user location for feed:", error)
      // Show content without location parameters
      this.showContent()
    }
  }

  loadFeedWithLocation(lat, lng) {
    // Build URL with location parameters
    const url = new URL(window.location)
    url.searchParams.set('user_lat', lat)
    url.searchParams.set('user_lng', lng)
    
    // Only add filter if it's not the default
    if (this.filterValue && this.filterValue !== 'all') {
      url.searchParams.set('filter', this.filterValue)
    }

    // Use Turbo to navigate to the URL with location parameters
    console.debug("Loading feed with location:", { lat, lng })
    Turbo.visit(url.toString(), { action: "replace" })
  }
} 